module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--21.bfc4d069.png";